export default function AboutSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200 text-secondary-800 text-xs font-semibold uppercase tracking-wide mb-6">
              System Features
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight leading-tight">
              Why the <span className="text-primary-500">Mulebuy<br />Spreadsheet</span> Works
            </h2>
            <p className="text-foreground-500 text-base md:text-lg mt-6 leading-relaxed max-w-lg">
              The Mulebuy spreadsheet method isn&apos;t just about rows and columns — it&apos;s a structured framework that transforms how you approach product sourcing, category management, and decision-making.
            </p>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-primary-600 rounded-2xl p-6 md:p-8 relative overflow-hidden">
              <div className="flex items-center justify-between mb-6">
                <span className="text-white/40 text-xs font-medium uppercase tracking-wider">Core Philosophy</span>
                <div className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-white/30"></span>
                  <span className="w-2 h-2 rounded-full bg-white/30"></span>
                  <span className="w-2 h-2 rounded-full bg-white/60"></span>
                </div>
              </div>
              <blockquote className="text-white text-lg md:text-xl font-medium leading-relaxed mb-6">
                &ldquo;Structure precedes clarity. When your product data lives inside a properly designed Mulebuy spreadsheet, what once felt like chaos becomes a clear, actionable pipeline.&rdquo;
              </blockquote>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                    <span className="text-white text-sm font-bold">MS</span>
                  </div>
                  <div>
                    <p className="text-white text-sm font-semibold">Mulebuy System</p>
                    <p className="text-white/50 text-xs">Spreadsheet Methodology</p>
                  </div>
                </div>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 text-white text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}